import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class TaskApi{
    static baseUrl = appConfig.gatewayUrl+appConfig.pdServicePath;
    // static baseUrl = "http://localhost:20065/pd-service" ;

    static ALL_POINT_TYPE = TaskApi.baseUrl + "/manage/xjTask/point/all"
    static SHOP_POINT_TEMPLATE = TaskApi.baseUrl + "/manage/xjTask/shopPoint/importTemplate"
    static IMPORT_SHOP_POINT = TaskApi.baseUrl + "/manage/xjTask/shopPoint/import"
    static PERSON_TEMPLATE = TaskApi.baseUrl + "/manage/xjTask/person/importTemplate"
    static IMPORT_PERSON = TaskApi.baseUrl + "/manage/xjTask/person/import"
    static SAVE_TASK = TaskApi.baseUrl + "/manage/xjTask/add"
    static QUERY_TASK_LIST = TaskApi.baseUrl + "/manage/xjTask/list"
    static TASK_DETAIL_DETAIL = TaskApi.baseUrl+"/manage/xjTask/detail";
    static UPDATE_TASK = TaskApi.baseUrl + "/manage/xjTask/update"
    static CHANGE_TASK_STATUS = TaskApi.baseUrl + "/manage/xjTask/status"
    static EXPORT_TASK = TaskApi.baseUrl + "/manage/xjTask/exportData"
	
	// static ALL_POINT_TYPE = "http://localhost:20065/pd-service" + "/manage/xjTask/point/all"
	// static TASK_DETAIL_DETAIL = "http://localhost:20065/pd-service"+"/manage/xjTask/detail";
	// static EXPORT_TASK = "http://localhost:20065/pd-service" + "/manage/xjTask/exportData"
	//  static QUERY_TASK_LIST = "http://localhost:20065/pd-service" + "/manage/xjTask/list"

    static allPointType(params){
        return httpGet(TaskApi.ALL_POINT_TYPE,params);
    }

    static shopPointTemplate(params){
        return httpDownload(TaskApi.SHOP_POINT_TEMPLATE,params);
    }

    static importShopPoint(file){
        let formData = new FormData()
        formData.append('file', file);
        return httpPost(TaskApi.IMPORT_SHOP_POINT, formData);
    }

    static personTemplate(params){
        return httpDownload(TaskApi.PERSON_TEMPLATE,params);
    }

    static importPerson(file){
        let formData = new FormData()
        formData.append('file', file);
        return httpPost(TaskApi.IMPORT_PERSON, formData);
    }

    static saveTask(param){
        return httpPost(TaskApi.SAVE_TASK,param);
    }

    static list(params){
        return httpGet(TaskApi.QUERY_TASK_LIST,params);
    }

    static detail(params){
        return httpGet(TaskApi.TASK_DETAIL_DETAIL,params);
    }

    static update(param){
        return httpPost(TaskApi.UPDATE_TASK, param);
    }

    static changeStatus(taskId, status){
        let formData = new FormData()
        formData.append('taskId', taskId);
        formData.append('status', status);
        return httpPost(TaskApi.CHANGE_TASK_STATUS, formData);
    }

    static exportData(param){
        return httpDownload(TaskApi.EXPORT_TASK,param);
    }


}